import { forwardRef, createElement } from 'react';

function IconAutotextInsert(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M14.75 5.75a.25.25 0 00-.193-.243L14.5 5.5H14a.75.75 0 01-.102-1.493L14 4h.5c.372 0 .718.116 1.001.315.242-.17.53-.28.841-.308L16.5 4h.5l.102.007a.75.75 0 010 1.486L17 5.5h-.5l-.057.007a.25.25 0 00-.184.175l-.009.068V8h4c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0120.25 16h-4v2.25l.007.057a.25.25 0 00.175.184l.068.009h.5l.102.007a.75.75 0 010 1.486L17 20h-.5l-.144-.006a1.74 1.74 0 01-.856-.308 1.734 1.734 0 01-.856.308L14.5 20H14a.75.75 0 01-.102-1.493L14 18.5h.5a.25.25 0 00.243-.193l.007-.057V5.75zm5.5 3.75h-4v5h4a.25.25 0 00.243-.193l.007-.057v-4.5a.25.25 0 00-.193-.243L20.25 9.5zM6 11a1 1 0 110 2 1 1 0 010-2zm3.5 0a1 1 0 110 2 1 1 0 010-2zm3.5 0c.087 0 .17.011.25.032v1.936A1.002 1.002 0 0112 12a1 1 0 011-1zm-9.25 5A1.75 1.75 0 012 14.25v-4.5C2 8.784 2.784 8 3.75 8h9.5v1.5h-9.5a.25.25 0 00-.243.193L3.5 9.75v4.5a.25.25 0 00.193.243l.057.007h9.5V16h-9.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var AutotextInsert = /*#__PURE__*/forwardRef(IconAutotextInsert);

export default AutotextInsert;
//# sourceMappingURL=AutotextInsert.js.map
